import React from 'react';
import colors from '../../styles/colors';

interface Product {
    id: string;
    icon: React.ReactNode;
}

interface Props {
    products: Product[];
    selected: string[];
    onSelect: (id: string) => void;
}

export const ProductCardsSelector: React.FC<Props> = ({
    products,
    selected,
    onSelect,
}) => {
    return (
        <div className="flex flex-wrap justify-center gap-4">
            {products.map(({ id, icon }) => {
                const isSelected = selected.includes(id);

                return (
                    <div
                        key={id}
                        onClick={() => onSelect(id)}
                        className={`w-16 h-16 rounded-xl border-4 cursor-pointer flex items-center justify-center transition-all duration-300 
                            ${isSelected
                                ? `border-white ring-2 ring-primary text-white`
                                : 'bg-[#E1F3FA] border-[#0076A8] text-[#005F86]'}`}
                        style={{
                            backgroundColor: isSelected ? colors.WaterBlue : undefined,
                        }}
                    >
                        <div className={`text-2xl ${isSelected? 'border-white text-white': 'text-[#005F86]'}`}>{icon}</div>
                    </div>
                );
            })}
        </div>
    );
};
